<template lang="pug">
  .purchaseFactors.blue-background
    .max-width-grid
      h4.white What are the most important factors behind a purchase?<span class="super white"><a href="https://solutions.ups.com/UPS-pulse-of-the-online-shopper-2019-LP.html?WT.mc_id=PRESSRELEASE_PRESSROOM_POTOS_STUDY_07301" target="_blank">8</a></span>
      MotiveBehindPurchase
</template>

<script>
import MotiveBehindPurchase from '@/assets/img/pieCharts/motiveBehindPurchase.svg'
import AnimationManager from '../scripts/AnimationManager'

export default {
  name: 'purchaseFactors',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
    const pieCharts = this.$el.querySelectorAll('.pieChart')

    pieCharts.forEach((chart, i) => {
      const timeline = new TimelineLite({ paused: true })
        .set(chart, {strokeDasharray:700})
        .fromTo(chart, 1.5, {strokeDashoffset:700, strokeDasharray:700}, { strokeDashoffset:0, ease: Power0.easeNone }, 0.5)
      AnimationManager.onEnterView(chart, () => {
        timeline.seek(0)
        timeline.play()
      })
    });
  },
  computed: {
  },
  methods: {
  },
  components: {
    MotiveBehindPurchase
  },
}
</script>

<style scoped lang="scss">
.purchaseFactors {
  text-align: center;
  padding: 5rem 0;

  h4 {
    // margin: 0;
  }
}
</style>
